<div class="zag-card-body">
  <ng-content></ng-content>
</div>
